import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingRigSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1h8v2h-1.5l2.143 12H23v2H1v-2h6.357L9.5 3H8V1zm1.389 14 1.786-10h1.65l1.786 10H9.39z"
    />
    <path d="M6 12H4v2h2v-2zm12 0h2v2h-2v-2zM1.7 19h2.332l-2.4 4H1v-2.833L1.7 19zm1.6 4h2.332l2.4-4H5.7l-2.4 4zm4 0h2.332l2.4-4H9.7l-2.4 4zm4 0h2.332l2.4-4H13.7l-2.4 4zm4 0h2.332l2.4-4H17.7l-2.4 4zm4 0h2.332L23 20.72V19h-1.3l-2.4 4z" />
  </svg>
);
export default IconDrillingRigSizeM;
